import React from 'react';
import Card from '../Card/Card';
import Publication from '../Publication';
import PublicationDetails from '../PublicationDetails';
import PublicationStats from '../PublicationStats/PublicationStats';
import PublicationActions from './PublicationActions';

if (process.browser) require('./SearchResultList.scss');

const track = { context: 'Search' };

export default function SearchResultList({
  items,
  query,
  currentPage,
}) {
  return (
    <Card
      className="publication-list"
      data-name="search-result-list"
    >
      {items.map((doc, i) => (
        <Publication
          className="publication-list-item"
          withStats="inline"
          key={doc.id}
        >
          <PublicationDetails
            doc={doc}
            track={track}
            query={query}
            currentPage={currentPage}
            position={i}
          />
          <PublicationStats
            readerCount={doc.readerCount}
            documentId={doc.id}
            scopusDocumentId={doc.identifiers && doc.identifiers.scopus}
            hideViewStat
          />
          <PublicationActions
            doc={doc}
            track={track}
            currentPage={currentPage}
            position={i}
          />
        </Publication>
      ))}
    </Card>
  );
}



// WEBPACK FOOTER //
// ./src/universal/ui/components/SearchResults/SearchResultList.js